import Parse from 'parse';
import { Provider } from '@angular/core';
import { ParseLabelConfigRepository } from '@telespot/infrastructure/parse';
import { SaveLabelConfigCommand } from '@protocols/use-cases';

import { LabelConfigState } from '../state/label-config.state';

import { LabelConfigSaveEffects, SAVE_LABEL_CONFIG_COMMAND } from './label-config-save.effects';

/**
 * The staged-label-config persist bundle: the shared ledger, the best-effort
 * save batch, and the command it drives.
 *
 * Spread by `saveProtocolCascadeProviders` (the cascade's tail delegates to the
 * batch) and provided directly by consumers that persist staged configs WITHOUT
 * the cascade — the labels page, whose whole save story is this bundle.
 *
 * `LabelConfigState` is a PAGE-tier staging ledger, so this bundle belongs to the
 * outermost consumer only — same caveat the cascade bundle carries for
 * `LabelState`. Spreading it in an injector BELOW an existing label-config tier
 * would shadow the outer ledger, and the batch would then find it empty.
 */
export const labelConfigSaveProviders: Provider[] = [
  LabelConfigState,
  LabelConfigSaveEffects,
  {
    provide: SAVE_LABEL_CONFIG_COMMAND,
    useFactory: () => new SaveLabelConfigCommand(new ParseLabelConfigRepository(Parse, { useMasterKey: false })),
  },
];
